import { apiRoutes } from "../services/apiRoutes";
import { DateFormater } from "../services/DateFormater";
import * as ReactDOMServer from 'react-dom/server';
import { htmlEncode } from "../services/Utils";

export const SearchData = (props) => {
	const { adjustForTimezone } = DateFormater();

	const getCorrectLocalization = (synonyms, cultureInfoCode, IsMfgName) => {
		let synType = 2;
		if (IsMfgName)
			synType = 4;

		if (synonyms.length === 0)
			return "";

		let localization = synonyms.find(x => x.cultureInfoCode === cultureInfoCode && x.synonymType === synType);
		if (localization != null)
			return localization.synonym;

		let languageSection = (cultureInfoCode.indexOf("-") !== -1) ? cultureInfoCode.substring(0, cultureInfoCode.indexOf("-") + 1) : cultureInfoCode;
		localization = synonyms.find(x => x.cultureInfoCode.indexOf(languageSection) !== -1 && x.synonymType === synType);
		if (localization != null)
			return localization.synonym;

		localization = synonyms.find(x => x.cultureInfoCode.indexOf("en-") !== -1 && x.synonymType === synType);
		if (localization != null)
			return localization.synonym;

		localization = synonyms.find(x => x.synonymType === synType);
		if (localization != null)
			return localization.synonym;

		if (IsMfgName)
			return null

		return synonyms[0].synonym;
	}

	const getLanguageOptions = async () => {
		let values = "";
		let json = await props.execute("GET", apiRoutes.documents.languages);
		if (json != null) {
			for (var i = 0; i < json.length; i++) {
				json[i].label = (props.localizations[json[i].languageName] ?? json[i].languageName) + " - " + json[i].country;
				json[i].value = json[i].languageId;
			}

			if (localStorage.getItem("languages")) {
				let ids = localStorage.getItem("languages").split(",");
				values = json.filter(x => ids.filter(y => y == x.languageId).length > 0);

			}
		}
		return { json, values };
	};

	const GetSearchData = async (searchArchive, searchPhrase, searchPhraseNoWildcard, localesSelected, searchPhraseCookie, searchPhraseNoWildcardCookie, languageValues, searchType, searchArch) => {
		let searchPhraseVal = searchPhrase;
		let searchPhraseNoWildcardCheck = searchPhraseNoWildcard;
		if (searchPhraseNoWildcardCookie != null)
			searchPhraseNoWildcardCheck = searchPhraseNoWildcardCookie;
		if (searchPhraseCookie != null)
			searchPhraseVal = searchPhraseCookie;

		if (searchPhraseNoWildcardCheck == null || searchPhraseNoWildcardCheck.length < 3)
			return;

		let languageIds = [];
		for (var i = 0; i < localesSelected.length; i++) {
			languageIds.push(localesSelected[i].value);
		}
		languageIds = languageIds.join(",");

		if (languageValues)
			languageIds = languageValues;

		localStorage.setItem("languages", languageIds);

		if (searchArchive || searchArch)
			searchArch = true;

		let response = await props.execute("GET", `${apiRoutes.materials.search}?searchPhrase=${encodeURI(searchPhraseVal)}&phrase=${(searchType === "2")}&languageIds=${localStorage.getItem("languages")}${searchArch ? "&searchArchive=true" : ""}`);

		if (response != null) {
			let documents = response.map(x => {
				if (x.timestamp_Create != null) {
					x.timestamp_CreateDisplay = adjustForTimezone(x.timestamp_Create.substring(0, x.timestamp_Create.indexOf("Z")), props.customer.TimezoneId);
					x.timestamp_Create = new Date(adjustForTimezone(x.timestamp_Create.substring(0, x.timestamp_Create.indexOf("Z")), props.customer.TimezoneId));
				}
				if (x.timestamp_Modified != null) {
					x.timestamp_ModifiedDisplay = adjustForTimezone(x.timestamp_Modified.substring(0, x.timestamp_Modified.indexOf("Z")), props.customer.TimezoneId);
					x.timestamp_Modified = new Date(adjustForTimezone(x.timestamp_Modified.substring(0, x.timestamp_Modified.indexOf("Z")), props.customer.TimezoneId));
				}

				x.materialName = getCorrectLocalization(x.synonyms, props.languageValue.languageCode, false);
				x.manufacturer = getCorrectLocalization(x.synonyms, props.languageValue.languageCode, true) ?? x.manufacturer;

				x.materialName = htmlEncode(x.materialName);
				x.manufacturer = htmlEncode(x.manufacturer);

				x.textValue1 = x.textValue1 == null ? "" : htmlEncode(x.textValue1);
				x.textValue2 = x.textValue2 == null ? "" : htmlEncode(x.textValue2);
				x.textValue3 = x.textValue3 == null ? "" : htmlEncode(x.textValue3);
				x.materialSourceId = htmlEncode(x.materialSourceId);

				x.materialCodesText = htmlEncode(x.materialCodes.join(', '));
				x.materialTags.sort((a, b) => a.tag.localeCompare(b.tag));

				if (x.casNumber != null) {
					let length = x.casNumber.length;
					if (x.casNumber.indexOf("-") === -1)
						x.casNumber = x.casNumber.slice(0, length - 3) + "-" + x.casNumber.slice(length - 3, length - 1) + "-" + x.casNumber.slice(length - 1);
				}

				let tagsUnique = [...new Set(x.materialTags.map(x => htmlEncode(x.tag)))];
				x.materialTagsTextDisplay = ReactDOMServer.renderToStaticMarkup(<div className="gridRowTags">{tagsUnique.map((y, index) =>
					<div className="sphera-chip" key={index + "matTag"} >
						<div className="k-chip k-selected k-focus k-chip-md k-rounded-md k-chip-solid k-chip-solid-base chip-purple s-chip">
							<span className="k-chip-content">
								<span className="k-chip-label">{y}</span>
							</span>
						</div>
					</div>)}</div>);
				x.materialTagsText = tagsUnique.join(" ");

				// Aggregated document-level columns render as an ellipsis-capped list (not chips),
				// with the full list in a tooltip. React escapes the title attr and text content.
				["documentFormats", "documentLocations", "documentTypes", "docText1s", "docText2s", "docText3s", "documentManufacturers"].forEach(f => {
					let listVals = [...new Set((x[f] || []).map(v => v.textValue).filter(Boolean))].sort((a, b) => a.localeCompare(b));
					let joined = listVals.join(", ");
					x[f + "Display"] = ReactDOMServer.renderToStaticMarkup(<div className="gridRowList" title={joined}>{joined}</div>);
					x[f + "Text"] = joined;
				});

				return x;
			});
			return { documents, searchPhraseVal };
		}
	}
	return {
		GetSearchData,
		getLanguageOptions,
		getCorrectLocalization
	};
}